import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TextboxOptions } from '../../../services/ui/modal.service';

@Component({
  selector: 'app-modal-box',
  templateUrl: './modal-box.component.html',
  styleUrls: ['./modal-box.component.scss'],
})
export class ModalBoxComponent implements OnInit {
  @Input() titleText = '';
  @Input() text = '';
  @Input() okButtonText = 'Ok';
  @Input() cancelButtonText = 'Cancel';
  @Input() color = '';
  @Input() type: 'modal' | 'submit' | 'twoAction';
  @Input() checkbox = false;
  @Input() checkboxText = '';
  @Input() secondCheckbox = false;
  @Input() secondCheckboxText = '';
  @Input() titleIcon = '';
  @Input() checkRequiredToSubmit: boolean = false;
  @Input() secondCheckRequiredToSubmit: boolean = false;
  @Input() smallTitleWidth: boolean = false;
  @Input() equalButtonsWidth: boolean = false;
  @Input() slotsFull: boolean = false;
  @Input() textbox: boolean = false;
  @Input() textboxOptions: TextboxOptions;
  @Input() modalWidth: string = '432px';
  @Input() titleSize: string = '16px';

  @Output() closeAction = new EventEmitter();
  @Output() modalAction = new EventEmitter();
  @Output() secondModalAction = new EventEmitter();
  @Output() modalActionWithCheckbox = new EventEmitter();
  @Output() modalActionWithTextbox = new EventEmitter<string>();
  @Output() modalCloseActionWithCheckbox = new EventEmitter();
  

  form: UntypedFormGroup;
  
  constructor(private fb: UntypedFormBuilder) {}
  ngOnInit(): void {
    this.form = this.fb.group({
      checkbox: new UntypedFormControl(),
      secondCheckbox: new UntypedFormControl(),
      textbox: new UntypedFormControl('', this.textboxOptions?.validations || [])
    });
  }

  onModalClose(event) {
    event.stopPropagation();
    if(this.checkbox){
      this.modalCloseActionWithCheckbox.emit(this.form.get('checkbox').value)
    }
    else
      this.closeAction.emit();
    
  }
  onOkClick(event){
    if(this.checkbox){
      this.modalActionWithCheckbox.emit(this.form.get('checkbox').value);
    }
    else if(this.textbox && this.textboxOptions){
      this.modalActionWithTextbox.emit(this.form.get('textbox').value);
    }
    else{
      this.modalAction.emit();
    }
    this.onModalClose(event);
  }

}
